import * as _dateTime from './date.util';
import * as _translate from './toro-translate.util';

export namespace ToroUtils {

    export import Translate = _translate.XXUseToroUtilsNamespace.Translate;
    export import ToroDate = _dateTime.XXUseToroUtilsNamespace.DateUtils;

}
